import { createFileRoute, notFound } from "@tanstack/react-router";
import {
  SettingsSurface,
  settingsSectionFromSlug,
  type SettingsSectionId
} from "../workspace/settings/SettingsSurface";

export const Route = createFileRoute("/settings/$section")({
  beforeLoad: ({ params }) => {
    if (!settingsSectionFromSlug(params.section)) {
      throw notFound();
    }
  },
  component: SettingsSectionRoute
});

function SettingsSectionRoute() {
  const search = Route.useSearch();
  const { section } = Route.useParams();
  return (
    <SettingsSurface
      activeFrameRecordId={search.frame ?? null}
      activeSection={settingsSectionFromSlug(section) as SettingsSectionId}
    />
  );
}
